export const DIRECT_SALES_ORDER = {
    BASE_PATH: '/direct-sale-order/sale-order/',
    CONVERT_TO_INVOICE_PATH(id: string | number) {
        return this.BASE_PATH + `${id}` + '/edit/convert-to-invoice';
    },
    ADD_PATH() {
        return this.BASE_PATH + 'add';
    },
    ADD_BUTTON_TITLE: 'Add New Direct Sales Order',
    LIST_PAGE_TITLE: 'Direct Sales Order List',
    EDIT_PAGE_TITLE: 'Edit Direct Sale Order',
    GET_ALL: 'direct-sale-order/sale-order',
    GET_ONE: 'direct-sale-order/sale-order/edit/',
    CREATE: 'direct-sale-order/sale-order',
    UPDATE: 'direct-sale-order/sale-order/update/',
    APPROVE: 'direct-sale-order/order-approval/update/',
    DELETE: 'direct-sale-order/sale-order/delete/',
    ADD_NEW_TITLE: 'Add New Direct Sale Order',
};
